import * as React from 'react';

import FileZip16 from './FileZip16';

export const fileZip16 = () => <FileZip16 />;

export default {
    title: 'Icon/Fill/FileZip16',
    component: FileZip16,
    parameters: {
        notes: "`import FileZip16 from 'box-ui-elements/es/icon/fill/FileZip16';`",
    },
};
